import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useMemo, useState } from 'react';

import ProgressWizard from 'components/field/ProgressWizard';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalTitle } from 'components/global/styled/Modal.styled';

import useAlert from 'hooks/useAlert';
import useMediaQuery from 'hooks/useMediaQuery';

import PaymentModal from 'pages/Settings/Payment/ManageSubscription/AddPaymentMethod/PaymentModal';

import { Breakpoints } from 'utils/const.styles';

import { faCreditCard } from '@fortawesome/pro-solid-svg-icons';

import * as S from './ImportOrderOnboardingModal.styled';
import VerifyCRSection from './Tabs/VerifyCRSection';

const ImportOrderOnboardingModal = NiceModal.create(({ startIndex, hasSavedCard }) => {
	const { showSuccess } = useAlert();
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const [cardLastFour, setCardLastFour] = useState('');

	const modal = useModal();
	const [tab, setTab] = useState(startIndex);

	const handleCloseModal = () => {
		modal.remove();
	};

	const nextStep = () => {
		if (tab < 2) setTab(tab + 1);
	};

	const tabs = useMemo(() => {
		const baseTabs = [
			{
				label: 'import.onboarding.CRVerification',
				icon: faCreditCard,
				component: () => <VerifyCRSection nextStep={nextStep} closeModal={handleCloseModal} />
			}
		];

		if (!hasSavedCard) {
			baseTabs.push({
				label: 'import.onboarding.payment',
				icon: faCreditCard,
				component: () => (
					<PaymentModal
						confirmationText="import.onboarding.paymentConfirmation"
						informationText="import.onboarding.paymentInformation"
						confirmButtonKey="import.onboarding.completeButton"
						setCardLastFour={setCardLastFour}
						closeModal={handleCloseModal}
						nextStep={nextStep}
					/>
				)
			});
		}

		return baseTabs;
	}, [handleCloseModal, nextStep, setCardLastFour, hasSavedCard]);

	const activeTab = useMemo(() => {
		return tabs[tab] ? tabs[tab].component() : null;
	}, [tab, tabs]);

	useEffect(() => {
		if (cardLastFour) {
			showSuccess();
			handleCloseModal();
		}
	}, [cardLastFour]);

	useEffect(() => {
		if (tab === tabs.length) {
			handleCloseModal();
		}
	}, [tab]);

	const getStages = (tabs) => {
		const stages = [];
		tabs.forEach((tab) => {
			stages.push({
				name: tab.label,
				icon: tab.icon
			});
		});
		return stages;
	};

	return (
		<Modal className={'import-order-onboarding-modal'} maxWidth="x-large" fullwidth>
			<ModalTitle>
				<Typography variant="p1">import.onboarding.title</Typography>
			</ModalTitle>

			<ProgressWizard
				className={isMobile ? 'mt-4' : ''}
				stages={getStages(tabs)}
				index={tab}
				setIndex={setTab}
				clickable={false}
				gutterBottom
			/>

			<S.ModalContainer>{activeTab}</S.ModalContainer>
		</Modal>
	);
});

export default ImportOrderOnboardingModal;
